<template>
  <div class="OrderStatus-root car-line-goods">
    <info-box title="线路及货品">
      <template slot="info">
        <a-table
          class="table"
          :columns="columns"
          :data-source="waybillList"
          size="small"
          :bordered="true"
          :pagination="false"
          :row-class-name="rowClass"
          :custom-row="customRow"
          :scroll="{ x: true }"
        >
          <!-- :scroll="{ x: '1500px'}" -->
          <!-- <a slot="name" slot-scope="text">{{ text }}</a> -->

          <span slot="temperatureLowest" slot-scope="text, record">
            <!-- <a>Invite 一 {{ text }}</a> -->
            {{ record.temperatureZones.join(",") }}
          </span>

          <span slot="loadWeight" slot-scope="text, record">
            共{{ record.loadNumber }} 件<br />
            共{{ record.loadWeight }}kg/{{ record.loadVolums }}M³
          </span>
          <span slot="price" slot-scope="text">
            {{ text | price }}
          </span>

          <span v-if="record.startLoadNumber || record.startLoadWeight || record.startLoadVolume" slot="startLoadWeight" slot-scope="text, record">
            共{{ record.startLoadNumber }} 件<br />
            共{{ record.startLoadWeight }}kg/{{ record.startLoadVolume }}M³
          </span>

          <span v-if="record.transportNumber || record.transportWeight || record.transportVolume" slot="transportWeight" slot-scope="text, record">
            共{{ record.transportNumber }} 件<br />
            共{{ record.transportWeight }}kg/{{ record.transportVolume }}M³
          </span>

          <span v-if="record.auditSum || record.auditWeight || record.auditVolume" slot="auditWeight" slot-scope="text, record">
            共{{ record.auditSum }} 件<br />
            共{{ record.auditWeight }}kg/{{ record.auditVolume }}M³
          </span>
        </a-table>
      </template>
    </info-box>
  </div>
</template>
<script>
import moment from "moment";
import { WaybillStatusText } from "@/pages/orderManage/constant.js";
import { orderLogList } from "@/pages/orderManage/api.js";

import InfoBox from "./InfoBox.vue";

export default {
  components: {
    InfoBox,
  },
  filters: {
    price(val) {
      return (val && val.toFixed(2)) || "";
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    isDemoData: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    const columns = [
      {
        title: "状态",
        dataIndex: "waybillStatus",
        width: 80,
        fixed: "left",
        // scopedSlots: { customRender: 'waybillStatus' },//引入的插槽
        customRender: (text, row) => {
          return {
            children: (
              <span>
                {this.getWaybillText(text)}
              </span>
            ),
            attrs: {
              rowSpan: row.waybillStatusRow,
            },
          };
        },
      },
      {
        title: "运单",
        dataIndex: "ind",
        width: 50,
        // fixed: "left",
        customRender: (text, row) => {
          return {
            children: (
              <span>
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>运单号 {row.waybillCode}</span>
                  </template>
                  <span class="numbers">{row.itemIndex + 1}</span>
                </a-tooltip>
              </span>
            ),
            attrs: {
              rowSpan: row.indRow,
            },
          };
        },
      },
      {
        title: "起始地",
        dataIndex: "shippingAddress",
        width: 220,
        customRender: (text, row) => {
          return {
            children: (
              <span>
                {text.receivingAddressCode}<br />
                {text.receivingAddressName}<br />
                {text.receivingUserName} {text.receivingUserPhone} <br />
                <a-tooltip placement="top">
                  <template slot="title">
                    <p>
                      {text.province}
                      {text.city}
                      {text.area}
                      {text.address}
                    </p>
                  </template>
                  <p class="address-txt">
                    {text.province}
                    {text.city}
                    {text.area}
                    {text.address}
                  </p>
                </a-tooltip>
              </span>
            ),
            attrs: {
              rowSpan: row.shippingAddressRow,
            },
          };
        },
      },
      {
        title: "目的地",
        dataIndex: "receivingAddress",
        width: 220,
        customRender: (text, row) => {
          return {
            children: (
              <span>
                {text.receivingAddressCode}<br />
                {text.receivingAddressName}<br />
                {text.receivingUserName} {text.receivingUserPhone} <br />
                <a-tooltip placement="top">
                  <template slot="title">
                    <p>
                      {text.province}
                      {text.city}
                      {text.area}
                      {text.address}
                    </p>
                  </template>
                  <p class="address-txt">
                    {text.province}
                    {text.city}
                    {text.area}
                    {text.address}
                  </p>
                </a-tooltip>
              </span>
            ),
            attrs: {
              rowSpan: row.receivingAddressRow,
            },
          };
        },
      },
      {
        title: '货品',
        dataIndex: "goodName",
        width: 200,
      },
      {
        title: "温区",
        dataIndex: "warmZoneName",
        scopedSlots: { customRender: "warmZoneName" },
        width: 100,
      },
      {
        title: "货值（元）",
        dataIndex: "price",
        scopedSlots: { customRender: "price" },
        width: 150,
      },
      {
        title: "计划量",
        dataIndex: "loadWeight",
        scopedSlots: { customRender: "loadWeight" },
        width: 160,
      },
      {
        title: "装载量",
        dataIndex: "startLoadWeight",
        scopedSlots: { customRender: "startLoadWeight" },
        width: 160,
      },
      {
        title: "签收量",
        dataIndex: "transportWeight",
        scopedSlots: { customRender: "transportWeight" },
        width: 160,
      },

      {
        title: "稽核量",
        dataIndex: "auditWeight",
        scopedSlots: { customRender: "auditWeight" },
        width: 160,
      },
      {
        title: "操作",
        dataIndex: "action",
        width: 100,
        fixed: "right",
        customRender: (text, row) => {
          return {
            children: (
              <span>
                <a-popover placement="bottomLeft" trigger="click">
                  <template slot="content">
                    <span class={this.logList.length === 0 ? "" : "hide"}>
                      暂无明细
                    </span>
                    <a-steps
                      class={this.logList.length === 0 ? "hide" : ""}
                      progress-dot
                      current={0}
                      size="small"
                      direction="vertical"
                      class="goodsStep"
                    >
                      {this.logList.map((item, index) => (
                        <a-step key={index}>
                          <template slot="title">
                             <b class="timeStyle">{this.formatTimestamp(item.createTime)}</b>
                            <b style="margin-right: 5px">
                              {item.operationType}
                            </b>
                            {item.operator}
                          </template>
                          <span slot="description" class="descriptionStep">
                            {item.message}
                          </span>
                        </a-step>
                      ))}
                    </a-steps>
                  </template>
                  <a
                    class="look-more"
                    on-click={() => this.getOrderLogList(row)}
                  >
                    查看明细
                  </a>
                </a-popover>
              </span>
            ),
            attrs: {
              rowSpan: row.waybillStatusRow,
            }
          }
        }
      },
    ];
    return {
      // data,
      columns,

      logList: [],
      waybillList: [],
    };
  },
  watch: {
    data(val) {
      const waybillList = [];
      val.map((listItem, itemIndex) => {
        const item = listItem
        item.goodsList.map((item2, index) => {
          const row = { ...item, ...item2 };
          const colAndRow = {
            indRow: 0,
            waybillStatusRow: 0,
            shippingAddressRow: 0,
            receivingAddressRow: 0,
          };
          if (index === 0) {
            colAndRow.indRow = item.goodsList.length;
            colAndRow.waybillStatusRow = item.goodsList.length;
            colAndRow.shippingAddressRow = item.goodsList.length;
            colAndRow.receivingAddressRow = item.goodsList.length;
            colAndRow.itemIndex = itemIndex;
          }
          if (row.shippingAddress === null) {
            row.shippingAddress = {
              address: "",
              area: "",
              city: "",
              province: "",
              receivingUserName: "",
              receivingUserPhone: "",
            };
          }
          waybillList.push({ ...row, ...colAndRow });
          return item2;
        });
        if (this.isDemoData) {
          const {receivingUserName = '',receivingUserPhone = ''} = item.shippingAddress || {}
            item.shippingAddress.receivingUserName = receivingUserName ? `${receivingUserName.slice(0, 1)}**` : '--';
            item.shippingAddress.receivingUserPhone = receivingUserPhone ?`${receivingUserPhone.slice(0,3)}****${receivingUserPhone.slice(receivingUserPhone.length-4,receivingUserPhone.length)}` : '--'
            item.receivingAddress.receivingUserName = item.receivingAddress.receivingUserName ? `${item.receivingAddress.receivingUserName.slice(0, 1)}**` : '--';
            item.receivingAddress.receivingUserPhone = item.receivingAddress.receivingUserPhone ?`${item.receivingAddress.receivingUserPhone.slice(0,3)}****${item.receivingAddress.receivingUserPhone.slice(item.receivingAddress.receivingUserPhone.length-4,item.receivingAddress.receivingUserPhone.length)}` : '--'
        }
        return item;
      });
      this.waybillList = waybillList;
    },
  },
  mounted(){
  },
  methods: {
    rowClass(record) {
      return `rowSpan${record.serialNumberTemp}`;
    },
    customRow() {
      return {
        on: {
          mouseenter: (event) => {
            this.mouseAction(event, 'add');
          },
          mouseleave: (event) => {
            this.mouseAction(event, 'remove');
            
          },
        }
      };
    },
    mouseAction(event, type) {
      const { classList } = event.target;
      let currentClass = '';
      for (let i = 0; i < classList.length; i+=1) {
        if (/rowSpan+/.test(classList[i])) {
          currentClass = classList[i];
          break;
        }
      }
      const eles = document.getElementsByClassName(currentClass);
      for (let i = 0; i < eles.length; i+=1) {
        eles[i].classList[type]('ant-table-row-hover');
      }
    },
    getWaybillText(val) {
      let result = "-";
      WaybillStatusText.map((item) => {
        if (item.value === val) {
          result = item.label;
        }
        return item
      });
      return result;
    },
    formatTimestamp(val) {
      return moment(val).format("YYYY-MM-DD HH:mm:ss");
    },
    async getOrderLogList(record) {
      this.logList = []
      const data = await orderLogList({
        orderType: 0,
        waybillCode: record.waybillCode,
      });
      const logList = data.logs;
      logList.sort((value1, value2) => value2.createTime - value1.createTime);
      // logList[0].operationType = "签收完成";
      // logList[2]["operationType"] = "指派司机";
      const hasText = ["签收完成", "装货完成", "指派司机"];
      this.logList = logList.filter((item) =>
        hasText.includes(item.operationType)
      );
      setTimeout(() => {
          const dom = [...document.getElementsByClassName('ant-steps-item-icon')]
          const domLine = [...document.getElementsByClassName('ant-steps-item-tail')]
          dom.forEach((e) => {
            e.style.left = '168px'
            e.style.position = 'absolute'
          })
          domLine.forEach((e) => {
            e.style.left = '161px'
            e.style.position = 'absolute'
          })
          document.getElementsByClassName('descriptionStep')[0].style.color = '#000'
      }, 200)
    },
  },
};
</script>
<style lang="less" scoped>
.stepsDescription {
  color: #08be77;
}
.goodsStep {
  .descriptionStep {
    font-size: 12px;
    width: calc(100% - 200px);
    display: inline-block;
    margin-left: 200px;
  }
}
.hide {
  display: none;
}
.look-more {
  font-size: 14px;
  color: #08be77;
  cursor: pointer;
  margin-left: 5px;
  &:hover {
    text-decoration: underline;
  }
}
.numbers {
  text-align: center;
  &:hover {
    color: #08be77;
  }
}
.address-txt {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style lang="less" >
.ant-steps-dot.goodsStep .ant-steps-item-content,
.ant-steps-dot.ant-steps-small.goodsStep .ant-steps-item-content {
  width: 600px;
}
.car-line-goods {
  .ant-descriptions-item > span {
    display: block;
  }
}
.timeStyle {
  width: 200px;
  display: inline-block;
}
</style>


